import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import LoginForm from '../../components/forms/LoginForm';
import NetworkBackground from '../../components/NetworkBackground';
import authService from '../../services/authService';
import styles from './LoginPage.module.css';

export default function AuthPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [message, setMessage] = useState('');
  const [showResend, setShowResend] = useState(false);
  const [emailToResend, setEmailToResend] = useState('');
  const [resendDisabled, setResendDisabled] = useState(false);

  const handleResend = async () => {
    setResendDisabled(true);
    const result = await authService.resendVerification(emailToResend);

    if (result.success) {
      setMessage(result.message || 'Verification email resent.');
      setShowResend(false);
    } else {
      setMessage(result.error || 'Failed to resend verification email.');
    }

    setTimeout(() => setResendDisabled(false), 60000);
  };

  const handleLogin = async (credentials) => {
    const result = await authService.login(credentials);

    if (result.success) {
      await login(result.token);
    
      navigate('/dashboard');
    
    } else {
      setMessage(result.error);
      if (result.code === 'UNVERIFIED') {
        setShowResend(true);
        setEmailToResend(credentials.email);
      } else {
        setShowResend(false);
      }
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <NetworkBackground />
      <div className={styles.authContainer}>
        <LoginForm 
          onLogin={handleLogin}
          errorMessage={message}
        />

        {showResend && (
          <button
            className={styles.resendButton}
            onClick={handleResend}
            disabled={resendDisabled}
          >
            {resendDisabled ? 'Please wait...' : 'Resend Verification Email'}
          </button>
        )}
      </div>
    </div>
  );
}
